export default __webpack_public_path__ + "static/media/inventory-green-icon.68b33aa2.svg";